import { Controller, useWatch } from "react-hook-form";
import { AsyncPaginate } from "react-select-async-paginate";
import * as z from "zod/v4";
const FormInputAsycnPaginate = ({ label, name, control, errors, loadOptions, placeholder = 'select...', onSelectedHandler }) => {
    // const value = watch(name)

    const value = useWatch({
        control,
        name, // The name of the field you want to watch
    });
    // console.log({ value })
    return (
        <div className="form-input">
            <label style={{ display: "block" }}>{label}</label>
            <Controller
                control={control}
                // defaultValue="1"
                name={name}
                rules={{ required: true }}
                render={({ field, name, ref }) => {
                    return (
                        <AsyncPaginate
                            placeholder={placeholder}
                            debounceTimeout={300}
                            name={field.name}
                            inputRef={field.ref}
                            classNamePrefix={"react-select"}
                            value={value}
                            onChange={async (val) => {
                                field.onChange(val);
                                await onSelectedHandler?.(val)

                            }}
                            loadOptions={loadOptions}
                        />
                    );
                }}
            />

            {errors[`${name}`] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[`${name}`]?.message}</p>}
        </div>
    )
}

export default FormInputAsycnPaginate